export function parseYearMonth(value: string) {
	const match = /^(\d{4})-(\d{2})$/.exec(value);
	if (!match) return null;
	const year = Number(match[1]);
	const month = Number(match[2]);
	if (!Number.isFinite(year) || month < 1 || month > 12) return null;
	return { year, month };
}

export function padMonth(month: number) {
	return String(month).padStart(2, '0');
}

export function createDefaultYears(centerYear: number) {
	return [centerYear - 1, centerYear, centerYear + 1];
}
